import { useCurrentWorkspace } from "@editor/contexts/WorkspaceDashboardContext";
import { workspaceRouter } from "@editor/trpc/workspace";

import { skipToken } from "@tanstack/react-query";
import { isNullish } from "replo-utils/lib/misc";

const useChatMessageLimits = ():
  | {
      hasUnlimitedMessages: true;
      messagesRemaining: null;
    }
  | {
      hasUnlimitedMessages: false;
      messagesRemaining: number;
    } => {
  const workspace = useCurrentWorkspace();

  const { data: chatMessageUsage } =
    workspaceRouter.getChatMessagesUsage.useQuery(
      !workspace?.id ? skipToken : workspace.id,
    );

  if (isNullish(chatMessageUsage?.maximum)) {
    return {
      hasUnlimitedMessages: true,
      messagesRemaining: null,
    };
  } else {
    const messagesRemaining =
      chatMessageUsage.maximum - chatMessageUsage.current;

    return {
      hasUnlimitedMessages: false,
      messagesRemaining,
    };
  }
};

export default useChatMessageLimits;
